<template>
  <div class="xiangmu">
    <Breadtabsheader/>
    <div class="h-piece h-mrt30">
      <div class="h-formBox">
        <div class="h-formBox">
          <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
            <div class="h-thirdColumn w-newColumn">
              <el-form-item label="新事业公司" style="width: 25%;">
                <brselect placeholder="请选择"
                          category="xsyb_gongsi"
                          :multiple="true"
                          :collapse-tags="true"
                          :v="q.newCompanyCodeStr"
                          clearable
                          v-model="q.newCompanyCodeStr">
                </brselect>
              </el-form-item>
              <el-form-item label="青岛本部公司" style="width: 25%;">
                <brselect placeholder="请选择"
                          category="xsyb_gongsi"
                          :multiple="true"
                          :collapse-tags="true"
                          :v="q.companyCodeStr"
                          clearable
                          v-model="q.companyCodeStr">
                </brselect>
              </el-form-item>
              <el-form-item label="新事业OEM服务类物料" style="width: 25%;">
                <el-input v-model="q.newMaterialStr" placeholder="请输入物料编码或名称"></el-input>
              </el-form-item>
              <el-form-item label="服务类物料" style="width: 25%;">
                <el-input v-model="q.materialStr" placeholder="请输入物料编码或名称"></el-input>
              </el-form-item>
            </div>
            <div class="h-thirdColumn w-newColumn">
              <el-form-item label="新事业代理商" style="width: 25%;">
                <el-input v-model="q.newAgentStr" placeholder="请输入代理商编码或名称"></el-input>
              </el-form-item>
            </div>
          </el-form>
          <div class="l-screenBox">
            <div class="l-retrieval">
              <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
              <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
              <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" style="width:2.2rem;"
                         @click="toNew">新增服务产品对照
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="h-table h-mrt30">
        <el-table
            :data="tableData"
            @selection-change="handleSelectionChange"
            ref="multipleTable"
            :border="true"
            style="width: 100%"
            max-height="450"
        >
          <el-table-column
              type="selection"
              width="40"
              :label="all"
          >
          </el-table-column>
          <el-table-column
              fixed
              type="index"
              label="#"
              width="40">
          </el-table-column>
          <el-table-column
              label="新事业公司编码"
              prop="newCompanycode"
              width="110">
          </el-table-column>
          <el-table-column
              label="新事业公司描述"
              prop="newCompanyname"
              show-overflow-tooltip
              width="220">
          </el-table-column>
<!--          <el-table-column-->
<!--              label="销售公司"-->
<!--              prop="companycode"-->
<!--              :show-overflow-tooltip="true"-->
<!--              width="180">-->
<!--            <template slot-scope="scope">-->
<!--              {{scope.row.companycode|dictname('xsyb_gongsi')}}-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column
              label="新事业代理商编码"
              prop="newAgentCode"
              width="110">
          </el-table-column>
          <el-table-column
              label="新事业代理商名称"
              prop="newAgentName"
              show-overflow-tooltip
              width="110">
          </el-table-column>
          <el-table-column
              label="新事业OEM服务类编码"
              prop="newMaterialCode"
              width="140">
          </el-table-column>
          <el-table-column
              label="新事业OEM服务类名称"
              prop="newMaterialName"
              show-overflow-tooltip
              width="110">
          </el-table-column>
          <el-table-column
              label="青岛本部公司代码"
              prop="companycode"
              width="110">
          </el-table-column>
          <el-table-column
              label="青岛本部公司描述"
              prop="companyname"
              show-overflow-tooltip
              width="110">
          </el-table-column>
          <el-table-column
              label="服务类编码H码"
              prop="materialCode"
              width="110">
          </el-table-column>
          <el-table-column
              label="服务类编码H码描述"
              prop="materialName"
              show-overflow-tooltip
              width="110">
          </el-table-column>
          <el-table-column
              label="创建人"
              prop="cuname"
              width="110">
          </el-table-column>

          <el-table-column
              label="创建时间"
              prop="cdate"
              width="110"
              :formatter="formatDate" >
          </el-table-column>

          <el-table-column
              fixed="right"
              label="操作"
              width="120"
          >
            <template slot-scope="scope">
<!--              <el-button-->
<!--                  type="text"-->
<!--                  size="small"-->
<!--                  class="h-tableLink h-btn" @click="toDetail(scope.row)">-->
<!--                查看-->
<!--              </el-button>-->
              <el-button
                  type="text"
                  size="small"
                  class="h-tableLink h-btn" @click="toChange(scope.row)">
                修改
              </el-button>
              <el-button
                  type="text"
                  size="small"
                  class="h-tableLink h-btn" @click="toDelete(scope.row)">
                删除
              </el-button>

            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="h-tableB h-mrt30">
        <div class="h-tableBL">
          <el-button type="primary" @click="exportExcel">批量导出</el-button>
        </div>
        <div class="h-pagination2">
          <pagination :page="q" @query="query"/>
        </div>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisibleAdd" class="h-dialog2 yonghu material-compare-dialog" @close="cancel('f')">
      <div class="h-dialogImg">
        <div class="h-disTable">
          <div class="h-tableCell" v-if="this.saveorupdate==1">
            <h1>新增服务公司间产品对照</h1>
            <p>New</p>
          </div>
          <div class="h-tableCell" v-if="this.saveorupdate==2">
            <h1>修改服务公司间产品对照关系</h1>
            <p>Update</p>
          </div>
        </div>
      </div>
      <div class="h-formLine h-mrb-38">
        <el-form :model="f" :rules="rules" ref="f"
                 :inline="true" class="demo-ruleForm h-formbLine h-dialogForm dialogForms">

          <el-form-item label="新事业OEM服务类编码" class="h-elformWrap-2" prop="newMaterialCode">
            <el-select v-model="f.newMaterialCode" remote filterable :filter-method="getProduct" clearable
                       placeholder="请输入"
                       :remote-method="getProduct" @change="selectProduct">
              <el-option v-for="(item) in productList"
                         :key="item.prodcode"
                         :label="item.prodcode"
                         :value="item.prodcode">
              </el-option>
            </el-select>

          </el-form-item>

          <el-form-item label="新事业OEM服务类名称" class="h-elformWrap-2" prop="newMaterialName">
            <el-input  placeholder="输入新事业OEM服务类编码自动带出" :v="f.newMaterialName" v-model="f.newMaterialName" :clearable="true" readonly/>
          </el-form-item>

          <el-form-item label="新事业公司" required class="h-elformWrap-2">
            <brselect placeholder="请选择"
                      category="xsyb_gongsi"
                      :v="f.newCompanycode"
                      clearable
                      v-model="f.newCompanycode"
                      disabled
                      @change="getAgentCode">
            </brselect>
          </el-form-item>

          <el-form-item label="新事业代理商编码" class="h-elformWrap-2" prop="newAgentCode">
            <el-input placeholder="输选择新事业公司自动带出" v-model="f.newAgentCode" readonly></el-input>
          </el-form-item>

          <el-form-item label="新事业代理商名称" class="h-elformWrap-2" prop="newAgentName">
            <el-input placeholder="输选择新事业公司自动带出" v-model="f.newAgentName" readonly></el-input>
          </el-form-item>

          <el-form-item label="服务类编码H码" class="h-elformWrap-2" prop="materialCode">
            <el-select v-model="f.materialCode" remote filterable :filter-method="getHProduct" clearable
                       placeholder="请输入"
                       :remote-method="getHProduct" @change="selectHProduct">
              <el-option v-for="(item) in hProductList"
                         :key="item.prodcode"
                         :label="item.prodcode"
                         :value="item.prodcode">
              </el-option>
            </el-select>

          </el-form-item>

          <el-form-item label="服务类编码H码描述" class="h-elformWrap-2" prop="materialName">
            <el-input  placeholder="输入服务类编码H码自动带出" :v="f.materialName" v-model="f.materialName" :clearable="true" readonly/>
          </el-form-item>

          <el-form-item label="青岛本部公司" required class="h-elformWrap-2">
            <brselect placeholder="请选择"
                      category="xsyb_gongsi"
                      :v="f.companycode"
                      clearable
                      disabled
                      v-model="f.companycode"
                      @change="getSupplierCode">
            </brselect>
          </el-form-item>

          <el-form-item label="青岛本部公司V码" class="h-elformWrap-2" prop="areaCode">
            <el-input placeholder="选择青岛本部公司编码自动带出" v-model="f.supplierCode" readonly></el-input>
          </el-form-item>

        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="h-btn h-formBtn h-bgwhite" @click="cancel('f')">取消</el-button>
        <el-button class="h-btn h-formBtn h-bgblueQ2" v-if="this.saveorupdate === '1'" @click="insert()">提交</el-button>
        <el-button class="h-btn h-formBtn h-bgblueQ2" v-if="this.saveorupdate === '2'" @click="update()">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
    import ss from '../../../api/SystemService'
    import updownfile from "@/utils/updownfile";
    import agentCopyService from "../../../api/loud/agent/agentCopyService";
    import supplierListService from "../../../api/personal/supplierListService";
    export default {
      components: {},
      data() {
        return {
          all: '全部',
          q: {
            pageSize: 10,
            pageNo: 1,
            total: 0,
            newMaterialStr:null,
            materialStr:null,
            newCompanyCodeStr:null,
            companyCodeStr:null,
            newAgentStr:null,
          },
          tableData:[],
          multipleSelection:[],
          dialogFormVisibleAdd:false,
          //新增/修改弹窗
          saveorupdate: null,
          f: {
            id:null,
            newCompanycode:null,
            companycode:null,
            newAgentCode:null,
            newAgentName:null,
            agentCode:null,
            agentName:null,
            newMaterialCode:null,
            newMaterialName:null,
            materialCode:null,
            materialName:null,
            supplierCode:null,
            supplierName:null,
          },
          agentList:[],
          rules: {
            newCompanycode:[{required: true, message: '新事业公司代码必填', trigger:'input'}],
            companycode:[{required: true, message: '青岛本部公司代码必填', trigger: 'input'}],
            newAgentCode:[{required: true, message: '新事业代理商名称必填', trigger:['change', ' blur','input']}],
            newMaterialCode:[{required: true, message: '新事业OEM服务类编码必填', trigger: 'change'}],
            materialCode:[{required: true, message: '服务类编码H码必填', trigger: 'change'}],
            supplierCode:[{required: true, message: '青岛本部公司V码必填', trigger: 'input'}],

          },
          productList:[],
          hProductList:[],
        }
      },
      methods: {
        query() {
          ss.chanpin.materailCompareSelectPage(this.q).then(rd => {
            this.q.total = rd.total;
            this.tableData = rd.records;
          })
        },
        handleFilter() {
          this.q.pageNo = 1;
          this.query();
        },
        resetData(){
          this.q = {
            newMaterialStr:null,
            materialStr:null,
            newCompanyCodeStr:null,
            companyCodeStr:null,
            newAgentStr:null,
            pageSize: 10,
            pageNo: 1,
            total: 0,
          }
        },
        toNew(){
          this.dialogFormVisibleAdd = true;
          this.saveorupdate = '1';
        },
        //选中
        handleSelectionChange(val) {
          this.multipleSelection = val;
        },
        //明细导出
        exportExcel() {
          updownfile.down("/api/swyl/v1/materialCompare/downloadExcel",this.q,"post",'data');
        },
        formatDate(row, column) {
          // 获取单元格数据
          let data = row[column.property]
          if(data == null || data == '') {
            return null
          }
          let dt = new Date(data)
          return this.$util.riQi3(dt);
        },
        //弹框关闭
        cancel(formName) {
          this.dialogFormVisibleAdd = false;
          this.f.id = null;
          this.f.newCompanycode = null;
          this.f.companycode = null;
          this.f.newAgentCode = null;
          this.f.newAgentName = null;
          this.f.agentCode = null;
          this.f.agentName = null;
          this.f.newMaterialCode = null;
          this.f.newMaterialName = null;
          this.f.materialCode = null;
          this.f.materialName = null;
          this.f.supplierCode = null;
          this.f.supplierName = null;
          this.saveorupdate = null;
          this.$refs[formName].resetFields();
        },
        //获取代理商
        showComList(value) {
          ss.netApi.selectOnlyName(value).then(res => {
            this.agentList = res.obj
          })
        },
        changeComlist(value){
          this.f.newAgentCode = value;
          if(this.agentList.length){
            for (var i = 0; i < this.agentList.length; i++) {
              if (this.agentList[i].usercode === value) {
                this.f.newAgentName = this.agentList[i].customerName1;
              }
            }
          }
        },
        //获取服务BE码物料
        getProduct(value){
          ss.chanpin.selectFwProduct(value,'s').then(res=>{
            this.productList = res.msg;
          })
        },
        //获取服务H码物料
        getHProduct(value){
          ss.chanpin.selectFwProduct(value,'fw').then(res=>{
            this.hProductList = res.msg;
          })
        },
        getAgentCode(value){
          var dictlist = this.$store.getters.dictlist("YLSalesOrganization_agent");
          var agentName = '';
          for (var i = 0; i < dictlist.length; i++) {
            if (dictlist[i].code == value) {
              agentName = dictlist[i].name;
            }
          }
          agentCopyService.getAgentByName(agentName).then(res => {
            console.log(res);
            if(res.f && res.obj){
              this.f.newAgentCode = res.obj.usercodeInfo;
              this.f.newAgentName = res.obj.usernameInfo;
            }else {
              this.f.newAgentCode = null;
              this.f.newAgentName = null;
            }
          })
        },
        getSupplierCode(value){
          var dictlist = this.$store.getters.dictlist("YLSalesOrganization_agent");
          var supplierName = '';
          for (var i = 0; i < dictlist.length; i++) {
            if (dictlist[i].code == value) {
              supplierName = dictlist[i].name;
            }
          }
          console.log(supplierName)
          supplierListService.getSupplierByName(supplierName).then(res => {
            if(res.f && res.obj){
              this.f.supplierCode = res.obj.usercode;
              this.f.supplierName = res.obj.userName;
            }else {
              this.f.supplierCode = null;
              this.f.supplierName = null;
            }
          })
        },
        selectProduct(value){
          if(this.productList.length > 0){
            for(var i = 0; i < this.productList.length; i++){
              if(this.productList[i].prodcode === value){
                this.f.newMaterialCode = this.productList[i].prodcode;
                this.f.newMaterialName = this.productList[i].promodel;
                this.f.newCompanycode = this.productList[i].companycode;
                this.getAgentCode(this.productList[i].companycode)
              }
            }
          }
        },
        selectHProduct(value){
          if(this.hProductList.length > 0){
            for(var i = 0; i < this.hProductList.length; i++){
              if(this.hProductList[i].prodcode === value){
                this.f.materialCode = this.hProductList[i].prodcode;
                this.f.materialName = this.hProductList[i].promodel;
                this.f.companycode = this.hProductList[i].companycode;
                this.getSupplierCode(this.hProductList[i].companycode);
              }
            }
          }
        },
        insert(){
          ss.chanpin.materailCompareInsert(this.f).then(res=>{
            if(res.f){
              this.cancel('f');
              this.$msg.msgs(res.msg);
              this.query();
            }
          })
        },
        update(){
          ss.chanpin.materailCompareUpdate(this.f).then(res=>{
            if(res.f){
              this.cancel('f');
              this.$msg.msgs(res.msg);
              this.query();
            }
          })
        },
        toDelete(value){
          this.$msg.confirm("确认删除？",()=>{
            ss.chanpin.materailCompareDeleteById(value.id).then(res => {
              if(res.f){
                this.$msg.msgs(res.msg);
                this.query();
              }
            })
          })

        },
        toChange(scope){
          this.f = JSON.parse(JSON.stringify(scope));
          this.saveorupdate = '2';
          this.dialogFormVisibleAdd = true;
        }
      },
      created() {
        this.query();
      },
    }
</script>
<style scoped>
.material-compare-dialog {
  width: 100%; /* 可以根据需要调整宽度值 */
}
</style>